export const getEmailFormData = (formData, values) => {
  const {
    subject,
    body,
    attachments,
    from,
    cc,
    bcc,
    appId,
    stageActionId,
    schedule_at,
    jobId,
    commTempId,
    contactId,
    cc_emails,
    bcc_emails,
    sender_id,
    ats_shared_email_id = undefined,
  } = values;

  if (from) formData.append('from', from);
  if (sender_id) formData.append('sender_id', sender_id);
  if (subject) formData.append('subject', subject);
  if (body) formData.append('body', body);
  if (appId) {
    formData.append('ats_application_id', appId);
  }
  if (stageActionId) formData.append('ats_job_stage_action_id', stageActionId);
  if (jobId) formData.append('ats_job_id', jobId);
  if (commTempId) formData.append('ats_comm_template_id', commTempId);
  if (contactId) formData.append('contact_id', contactId);
  cc?.forEach((id) => formData.append('cc_user_ids[]', id));
  bcc?.forEach((id) => formData.append('bcc_user_ids[]', id));
  cc_emails?.forEach((email) => formData.append('cc_emails[]', email));
  bcc_emails?.forEach((email) => formData.append('bcc_emails[]', email));

  if (schedule_at && typeof schedule_at === 'string') {
    formData.append('scheduled_at', schedule_at);
  } else if (schedule_at) {
    if (schedule_at.formattedTime) {
      formData.append('scheduled_at', schedule_at.formattedTime);
    }
    if (schedule_at.timezoneValue) {
      formData.append('timezone', schedule_at.timezoneValue.key);
    }
  }

  // Only process attachments if they're not null
  if (attachments && Array.isArray(attachments)) {
    attachments.forEach((file) => {
      if (file instanceof File) formData.append('attachments[]', file);
      if (file?.id) {
        formData.append('attachments[]', file?.id);
      }
    });

    if (attachments.length === 0) {
      formData.append('attachments[]', []);
    }
  }

  //note: this is conditionally added for shared emails
  if (ats_shared_email_id) {
    formData.append('ats_shared_email_id', ats_shared_email_id);
  }

  return formData;
};
